import React from 'react';
import {
  CheckCircleOutline as CheckCircleOutlineIcon,
  Check as CheckIcon,
  ErrorOutline as ErrorOutlineIcon,
} from '@mui/icons-material';
import { MessageBoxIconProps } from './MessageBox.props';

const MessageBoxIcon = ({ type = 'info' }: MessageBoxIconProps) => {
  switch (type) {
    case 'success':
      return <CheckIcon className="message-box__icon" data-testid="message-box__icon" />;
    case 'success-inside':
      return <CheckCircleOutlineIcon className="message-box__inside-icon-ok" data-testid="message-box__icon" />;
    case 'error-inside':
      return <ErrorOutlineIcon className="message-box__inside-icon-error" data-testid="message-box__icon" />;
    case 'error-disabled':
      return <ErrorOutlineIcon className="message-box__icon-error-disabled" data-testid="message-box__icon" />;
    default:
      return <ErrorOutlineIcon className="message-box__icon" data-testid="message-box__icon" />;
  }
};

export default MessageBoxIcon;
